import { render } from "./ProjectProductCardList.vue?vue&type=template&id=9510ce68"
import script from "./ProjectProductCardList.vue?vue&type=script&lang=js"
export * from "./ProjectProductCardList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__